import React from "react";
import {ImgContainer, Title} from "./formsStyle";

function SideImage() {

    return(
        <ImgContainer>
            <Title>Drive Safe With Us</Title>
        </ImgContainer>
    )
}

export default SideImage;